export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  multFieldLine: {
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },

  dialogContent: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
    color: theme.custom.colors.text,

    borderTopColor: theme.custom.colors.hover,
    borderBottomColor: theme.custom.colors.hover,
  },

  dialogActions: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
    color: theme.custom.colors.text,
  },
  btnWrapper: {
    position: 'relative',
    color: '#FFF',
    backgroundColor: theme.custom.colors.confirmButton,
  },

  buttonProgress: {
    color: '#4caf50',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  attachButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.editButton,
  },
  cancelButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.cancelButton,
  },
});
